import * as React from 'react';

import {ReactableColumnDef} from '@deviceinsight/ng-ui-components';
import {DataProcessingDefinition} from '../../../../../../../api/dataProcessingDefinitionApi';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

export const getColumnDefs = (
	onClick: (kpi: DataProcessingDefinition) => any
): Array<ReactableColumnDef<DataProcessingDefinition>> => {
	return [
		{
			name: 'kpiName',
			label: <Trans i18nKey="asset.detail.dataProcessingDefinition.columns.kpiName">Name</Trans>,
			width: '18%',
			sortable: true,
			onClick,
			filterable: {
				filterType: 'text',
				filterFn: (item: DataProcessingDefinition, value: string) =>
					item.definition.kpiName.toLowerCase().indexOf(value.toLowerCase()) >= 0
			},
			render: (item: DataProcessingDefinition) => item.definition.kpiName
		},
		{
			name: 'processingPeriod',
			label: (
				<Trans i18nKey="asset.detail.dataProcessingDefinition.columns.processingPeriod">
					Processing period
				</Trans>
			),
			width: '18%',
			sortable: true,
			onClick,
			filterable: {
				filterType: 'text',
				filterFn: (item: DataProcessingDefinition, value: string) => {
					return item.definition.processingPeriod.toLowerCase().indexOf(value.toLowerCase()) >= 0;
				}
			},
			render: (item: DataProcessingDefinition) => (item.id ? item.definition.processingPeriod : '-')
		},
		{
			name: 'inputDatapoints',
			label: (
				<Trans i18nKey="asset.detail.dataProcessingDefinition.columns.inputDatapoints">Input variables</Trans>
			),
			width: '18%',
			onClick,
			render: (item: DataProcessingDefinition) => {
				const {
					definition: {input}
				} = item;
				return <span>{input.length}</span>;
			}
		},
		{
			name: 'outputKpi',
			label: <Trans i18nKey="asset.detail.dataProcessingDefinition.columns.outputKpi">Output KPI</Trans>,
			width: '18%',
			sortable: true,
			render: (item: DataProcessingDefinition) =>
				item.id ? item.definition.output.map((dp) => dp.variableName).join(',') : ''
		}
	];
};
